import { ContractorField } from "@/pages/contractor-profile/contractor/types";
import { useOperationsWithAttachmentsProps } from "@/pages/contractor-profile/hooks/types";
import { SubcontractorField } from "@/pages/contractor-profile/subcontractor/edit/types";
import { getBase64 } from "@/utils/get-base64";
import { getFileFormat } from "@/utils/get-file-format";
import { map } from "lodash";
import { ChangeEvent, useCallback, useEffect } from "react";

export const useOperationsWithAttachments = ({
  getValues,
  setValue,
  clearErrors,
  trigger,
}: useOperationsWithAttachmentsProps) => {
  const data = getValues();

  useEffect(() => {
    if (data?.attachments) {
      map(data?.attachments, (attachmentData, key) => {
        setValue(key, attachmentData);
      });
    }
  }, [data?.attachments, setValue]);

  const handleUploadDocument = useCallback(
    (
      e: ChangeEvent<HTMLInputElement>,
      fieldName:
        | SubcontractorField.TRADE_LICENSE
        | ContractorField.TRADE_LICENSE,
    ) => {
      clearErrors();
      const file = e.target.files?.[0] ?? null;

      if (file) {
        getBase64(file, async base64 => {
          if (base64) {
            setValue(ContractorField.TRADE_LICENSE, base64);
            setValue(ContractorField.TRADE_LICENSE_FILE_NAME, file.name);
            setValue(
              ContractorField.TRADE_LICENSE_FILE_FORMAT,
              getFileFormat(file.type),
            );
          }

          await trigger(fieldName);
        });
      }
    },
    [clearErrors, setValue, trigger],
  );

  const handleRemoveDocument = useCallback(
    (
      fieldName:
        | SubcontractorField.TRADE_LICENSE
        | ContractorField.TRADE_LICENSE,
    ) => {
      setValue(ContractorField.TRADE_LICENSE, null);
      setValue(ContractorField.TRADE_LICENSE_FILE_NAME, null);
      setValue(ContractorField.TRADE_LICENSE_FILE_FORMAT, null);

      trigger(fieldName);
    },
    [setValue, trigger],
  );

  return {
    onUploadDocument: handleUploadDocument,
    onRemoveDocument: handleRemoveDocument,
  };
};
